export const BOOKING_URL = "https://www.kqzyfj.com/click-101916125-11680307";

export const openBooking = () => {
  window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
};
